module.exports = "/_next/static/images/Hero-5b7ad5dc75b9b7279ae9e5df877b5031.webp";